import { useRef, useState } from "react";
import { Camera, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";

const compress = (file) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, 1280 / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = img.width * scale;
      c.height = img.height * scale;
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      c.toBlob((b) => resolve(b || file), "image/jpeg", 0.72);
    };
    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });

const toDataUrl = (blob) => new Promise((r) => { const fr = new FileReader(); fr.onload = () => r(fr.result); fr.readAsDataURL(blob); });

export const PhotoInput = ({ value, onChange, data, onData, guest, testid = "photo" }) => {
  const { t } = useApp();
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const blob = await compress(f);
      if (guest) return onData(await toDataUrl(blob));
      const fd = new FormData();
      fd.append("file", blob, "photo.jpg");
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  if (value || data)
    return (
      <div className="relative w-fit">
        <img src={data || fileUrl(value)} alt="scrap" className="h-32 w-32 rounded-2xl object-cover" data-testid={`${testid}-preview`} />
        <button type="button" onClick={() => (data ? onData("") : onChange(""))} data-testid={`${testid}-remove-btn`}
          className="absolute -right-2 -top-2 rounded-full bg-[#E05C3A] p-1 text-white"><X className="h-4 w-4" /></button>
      </div>
    );
  return (
    <>
      <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden" onChange={pick} data-testid={`${testid}-file-input`} />
      <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid={`${testid}-add-btn`}
        className="flex h-14 w-full items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-[#2E9E6B] bg-white font-semibold text-[#2E9E6B]">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Camera className="h-5 w-5" />}
        {busy ? t("Uploading…") : t("Add a photo (optional)")}
      </button>
    </>
  );
};
